<template>
    <component :is="'VuePerfectScrollbar'" ref="filterScroll" class="filters_scroll_area"  :settings="settings" :key="$vs.rtl">

        <div class="todo__filters-container">
            <div>
                <div class="px-6 py-4">
                    <!-- Кнопка сбросить фильтр -->
                    <div class="flex cursor-pointer" @click="filterRouteAll()">
                        <feather-icon icon="FilterIcon" svgClasses="h-6 w-6"></feather-icon>
                        <span class="text-lg ml-3">{{$t('show_all')}}</span>
                    </div>
                </div>

                <vs-divider class="mb-0 mt-0"></vs-divider>

                <!-- Фильтры -->
                <div class="px-6 py-4 border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid" v-for="(filter, name, index) in filterActive" :key="`f_${index}`">
                    <h5 class="mb-3 select_label">{{$t(name)}}</h5>
                    <multiselect
                        v-model="filterActive[name]"
                        :options="dynamicOptions(name)"
                        label=""
                        :selectedLabel="$t('selected')"
                        :placeholder="$t(name)"
                        @open="openSelect"
                        @close="selectClose"
                        @select="multiselectAction($event, name)"
                        @remove="multiselectRemove($event, name)"
                        deselectLabel=""
                        selectLabel=""
                        track-by="">

                            <div slot="noOptions">
                                {{$t('no_data_text')}}
                            </div>
                    </multiselect>
                </div>

                <div class="px-6 py-4 lg:hidden">
                    <vs-button @click="sidebarToggle()" class="w-full">{{$t('apply')}}</vs-button>
                </div>
            </div>
        </div>
    </component>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapState, mapMutations } from "vuex";
export default {
    props: {
        itemHandler: {
            type: Function,
            default: () => {}
        },
        requiredFilter: {
            type: Array
        },
        sidebarToggle: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.60
            },
            loading: false,
            filterActive: {
                acad_periods: null,
                groups: null,
                discipline: null,
                study_period: null,
                load_type: null
            }
        }
    },
    created: function() {
        this.setActiveFilter()
    },
    computed: {
        ...mapState({
            acad_periods: state => state.e_journal.acad_periods,
            groups: state => state.e_journal.groups,
            discipline: state => state.e_journal.discipline,
            study_period: state => state.e_journal.study_period,
            load_type: state => state.e_journal.load_type
        }),
        scrollbarTag () { return this.$store.getters.scrollbarTag }
    },
    methods: {
        setActiveFilter() {
            // Перебираем query параметры если они есть, и устанавливаем активные фильтры
            const query = this.$route.query
            if (Object.keys(query).length) {
                for (let key in query) {
                    this.filterActive[key] = query[key]
                }
            }
        },
        updateHandler(query = null) {
            this.$store.commit('e_journal/SET_INFO_SIDEBAR', false)
            this.$store.commit('e_journal/SET_QUERY', query)
        },
        multiselectAction(item, key) {
            let query = Object.assign({}, this.$route.query)
            query[key] = item

            // Обновляем роут
            this.$router.push({query})

            // Обновляем список
            this.updateHandler(query)
        },
        multiselectRemove (item, key) {
            let query = Object.assign({}, this.$route.query)
            delete query[key]

            // Обновляем роут
            this.$router.push({query})

            // Обновляем список
            this.updateHandler(query)
        },
        selectClose() {
            // Инициализируем скролл
            this.$refs['filterScroll'].__init()
        },
        openSelect(type) {
            // Останавливаем скролл
            this.$refs['filterScroll'].__uninit()
        },
        dynamicOptions(name) {
            // Так как поле настроек видимости выводиться в цикле, через эту функцию подставляем нужные данные в поле
            return this[name]
        },
        filterRouteAll() {
            // При нажатии на кнопку показать все, убираем все фильтры и обновляем список умк
            //this.$store.commit('isc/CLEAR_ISC_DISCIPLINES')

            if(Object.keys(this.$route.query).length) {
                this.$router.push({name: 'e-journal'})
                for (let query in this.filterActive) {
                    this.filterActive[query] = ''
                }

                // Обновляем список
                this.updateHandler()
            }
        }
    },
    components: {
        VuePerfectScrollbar
    }
}
</script>

<style scoped lang="scss">
.select_label{
    &.required{
        &::after{
            content: "*";
            color: rgba(var(--vs-danger),1);
            display: inline-block;
            margin-left: 3px;
        }
    }
}
</style>

<style lang="scss">
.todo__filters-container{
    .multiselect__single{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
</style>
